const lang = {
	EN: {
		catalogTitile: 'CATALOG',
		onaslink: 'ABOUT US',
		dostpaylink: 'SHIPPING AND PAYMENT',
		contactlink: 'CONTACTS',
		gift_cardlink: 'Gift card',
		aksessuary: 'Accessories',
		sumki: 'Bags',
		'braslet-reptiliia': 'Crocodile bracelet',
		koltsa: 'Rings',
		braslety: 'Bracelets',
		sergi: 'Earrings',
		brelok: 'Bracelet/keychain',
		kole: 'Necklace',
		obuv: 'Shoes',
		headerBrandSection: 'BRANDS',
		seeAll: 'SHOW ALL'
	},
	'': {
		catalogTitile: 'КАТАЛОГ',
		onaslink: 'О НАС',
		dostpaylink: 'ДОСТАВКА И ОПЛАТА',
		contactlink: 'КОНТАКТЫ',
		gift_cardlink: 'Подарочная карта',
		aksessuary: 'Аксессуары',
		sumki: 'Сумки',
		'braslet-reptiliia': 'Браслет крокодил',
		koltsa: 'Кольца',
		braslety: 'Браслеты',
		sergi: 'Серьги',
		brelok: 'Браслет/брелок',
		kole: 'Колье',
		obuv: 'Обувь',
		headerBrandSection: 'БРЕНДЫ',
		seeAll: 'ПОКАЗАТЬ ВСЕ'
	},
	KZ: {
		catalogTitile: 'КАТАЛОГ',
		onaslink: 'БІЗ ТУРАЛЫ',
		dostpaylink: 'ЖЕТКІЗУ ЖӘНЕ ТӨЛЕУ',
		contactlink: 'БАЙЛАНЫСТАР',
		gift_cardlink: 'Сыйлық картасы',
		aksessuary: 'Аксессуарлар',
		sumki: 'Сөмкелер',
		'braslet-reptiliia': 'Қолтырауын білезігі',
		koltsa: 'сақиналар',
		braslety: 'Білезік',
		sergi: 'Сырғалар',
		brelok: 'Білезік/брелок',
		kole: 'ожерелье',
		obuv: 'аяқ киім',
		headerBrandSection: 'БРЕНДТЕР',
		seeAll: 'БАРЛЫҒЫН КӨРСЕТУ'
	},
	ARM: {
		catalogTitile: 'ԿԱՏԱԼՈԳ',
		onaslink: 'ՄԵՐ ՄԱՍԻՆ',
		dostpaylink: 'ԱՌԱՔՈՒՄ ԵՎ ՎՃԱՐՈՒՄ',
		gift_cardlink: 'Նվեր քարտ',
		contactlink: 'ԿՈՆՏԱԿՏՆԵՐ',
		aksessuary: 'Աքսեսուարներ',
		sumki: 'Պարկեր',
		'braslet-reptiliia': 'Կոկորդիլոսի ապարանջան',
		koltsa: 'մատանիներ',
		braslety: ' Ապարանջաններ',
		sergi: 'ականջօղեր',
		brelok: 'Թևնոց/բանալին',
		kole: 'Վզնոց',
		obuv: 'Կոշիկ',
		headerBrandSection: 'ԲՐԵՆԴՆԵՐ',
		seeAll: 'ՑՈՒՅՑ ՏԱԼ ԱՄԲՈՂՋԸ'
	}
};

export { lang };
